export default {
  fillInformation: 'Ingrese a continuación los datos del cliente',
  thirdPartyInformation: 'En caso de requerir mayor información ¿necesitas que contactemos a un tercero?',
  message: 'Ingresa a continuación la información solicitada.',
  perfect: 'Perfecto!',
  completeInformation: 'Completa los datos de contacto de la persona que debemos contactar.',
  ownName: '¿Radica a nombre propio?',
  optionSelect: 'Seleccione',
  optionYes: 'Sí',
  optionNo: 'No',
  documentType: 'Tipo de documento *',
  documentNumber: 'Número de documento *',
  fullName: 'Nombre completo*',
  petitionerDocumentType: 'Tipo de documento',
  petitionerDocumentNumber: 'Numero de documento',
  petitionerFullName: 'Nombre',
  phone: 'Teléfono *',
  email: 'Correo Electrónico *',
  requiredfields: 'Campos obligatorios (*)',
  validInputMessage: 'Debe llenar los campos obligatorios',
  invalid_email: 'Verifique el email ingresado es valido',
  next_step: 'Siguiente',
  cancel: 'Cancelar'
}
